function toggleCartReturnPolicy() {
  if (!window.isCartPage) return;

  const cartRows = $('.cart__row.cart-item[data-return-excluded]');
  const shouldShowReturnPolicy = cartRows.toArray().some((row) => $(row).attr('data-return-excluded') === 'false');

  $('.cart-info-return').toggleClass('hideReturnPolicy', !shouldShowReturnPolicy);
  $('.mobile-policy-return-btn').toggleClass('hideReturnPolicy', !shouldShowReturnPolicy);
}

const UpdateCartItems = {
  plusButton: '.cart .qtyBtn.plus',
  minusButton: '.cart .qtyBtn.minus',
  removeButton: '.cart .cart__remove',
  updateButton: '.cart-update',
  updateQtyInput: '.cart .cart__qty-input',
  proceedCheckoutButton: '#cartCheckout',
  redirection: 'cart',
  requestInProgress: false, 
  pathAjax: `${location.protocol}//${location.host}${location.pathname}?sections=cart-template,cart_object`,
  _init: function () {
    this._addClickEventAddOrRemove();
    this._addClickEventRemove();
    this._addChangeEventQty();
  },
  _preEventActions: async function() {
    $('body').addClass('loading');
  },
  _postEventActions: async function() {
    var self = this;
    const totalItems = CartJS.cart.items.length;
    if(totalItems < 1) {
      self._cleanCartUi();
    }else {
      const totalItemsInCart = CartJS.cart.items.reduce((total_items, item) => {
        if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return total_items;
        return total_items + item.quantity;
    },0);
      $('#asm-subtotal-title .items-count')?.html(totalItemsInCart);
    }
    forcetoUpdateASMwoZIP();
    await updateSections(self.pathAjax, 0);
    toggleCartReturnPolicy();
    // FCP-01 - after any CartJS event
    calculateCartPrices();
    // $('#cartItemsId tbody').removeClass('overlay');
    // $('#asm-mini-cart').removeClass('overlay');
  },
  _addClickEventAddOrRemove: function () {
    console.log('add click event add or remove');
    var self = this;
    $('.cart').on("click", `${this.plusButton}, ${this.minusButton}`, async function() {
      if(!$(this).hasClass('disabled') && $(this).closest('#cartItemsId tbody').length) {
        await self._preEventActions();
        const row = $(this).closest('.cart__row');
        const variantId = row.data('variant-id');
        const action = $(this).attr("data-action");
        const currentQty = parseInt($(this).parent().find('.cart__qty-input').attr('value'));
        const newQty = action == "plus" ? parseInt(currentQty) + 1 : parseInt(currentQty) - 1;
        // $(this).parent().find('.cart__qty-input').val(newQty).change();
        var index = row.data('index');
        self._updateCartJsByVariant(variantId, newQty,index);
      }
    });
  },
  _addClickEventRemove: function () {
    console.log('add click event remove _addClickEventRemove');
    var self = this;
    $('.cart').on("click", this.removeButton, async function() {
      if($(this).closest('#cartItemsId tbody').length) {
        console.log('add click event remove _addClickEventRemove 1');
        await self._preEventActions();
        const row = $(this).parents('.cart__row');
        const variantId = row.data('variant-id');
        const newQty = 0;
        if($(this).hasClass("templok-remove")){
          console.log('add click event remove _addClickEventRemove 2');
          let data = {};
          let templokregularId = parseInt($(this).attr('datatemplok'))
          let templokId = parseInt($(this).attr('datacurrentid'))
          if(!isNaN(templokregularId)){
            data[templokregularId] = 0
          }
          if(!isNaN(templokId)){
            console.log('add click event remove _addClickEventRemove 3');
            data[templokId] = 0
          }
          console.log('add click event remove _addClickEventRemove 4',data);

          CartJS.updateItemQuantitiesById(data);
        }else{
          console.log('add click event remove _addClickEventRemove 5');
           console.log('add click event remove _addClickEventRemove 5 row.data',row.data());

          const variantIndex = row.data('index');
          self._updateCartJsByVariant(variantId, newQty,variantIndex); //variant is removed by setting the count to 0, so we are sending index to remove the correct item in case of multiple same variants in cart
          console.log('window.mozVendor.count',window.mozVendor.count);
          if (row.data('variantVendor') =="Moz Designs"){
            console.log('before inside window.mozVendor.count',window.mozVendor.count);
            window.mozVendor.count = window.mozVendor.count - 1;
            console.log('after inside window.mozVendor.count',window.mozVendor.count);
          }
          if (window.mozVendor.count  <= 0) {
            // Show quote tool and checkout buttons when last Moz product is removed
              console.log('inside window.mozVendor.count',window.mozVendor.count);
              console.log('consentValue',window.consentValue)
              setTimeout(function() {
                $('.quote-modal-wrapper').removeClass('tw-hidden');
                $('.additional-checkout-buttons').removeClass('tw-hidden').show();
              }, 500);
           } else {
              // Hide checkout buttons when Moz products exist
              $('.additional-checkout-buttons').addClass('tw-hidden').hide();
           }
        }
        var cartIndexVal = $(this).closest('.cart-flex').data( "install-enabled" );    
        console.log('the items in cart after remove',CartJS.cart.items);         
        if(typeof items === 'undefined') return;
        if(cartIndexVal===true){
          console.log('add click event remove _addClickEventRemove 6');
          //enabledInstallationProductsCountJS=enabledInstallationProductsCountJS-1;
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
        } 
        else if (cartIndexVal===''){
          console.log('add click event remove _addClickEventRemove 7');
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
          itemsEnableInstallationMissingCountJS=itemsEnableInstallationMissingCountJS-1;
        } 
        else if (cartIndexVal===false){
          rivets.formatters.checkVendorLogo(items, cartIndexVal);
        }
      }
    });
  },
  _addChangeEventQty: function() {
    console.log('_addChangeEventQty add change event qty');
    var self = this;
    $(document).on('change', this.updateQtyInput, async function(e) {
      if($(this).closest('#cartItemsId tbody').length) {
        let min_quantity = parseInt($(this).attr('data-min') != ""?$(this).attr('data-min'): 1);
        let max_quantity = parseInt($(this).attr('data-max'));
        let item_id = $(this).attr('data-item');
        let current_value = $(this).val();
        if(min_quantity && current_value <= min_quantity ){
          $(this).parents('.qtyField').find('.minus').addClass('disabled');
          if(current_value < min_quantity){
            $(this).val(min_quantity);
            window.cart_min_max_error = {
              id: item_id,
              validation: "min",
              min_quantity: min_quantity,
              max_quantity: max_quantity
            }
          }
        }else{
          $(this).parents('.qtyField').find('.minus').removeClass('disabled');
        }
        if(max_quantity && current_value >= max_quantity ){
          $(this).parents('.qtyField').find('.plus').addClass('disabled');
          if(current_value > max_quantity){
            $(this).val(max_quantity);
            window.cart_min_max_error = {
              id: item_id,
              validation: "max",
              min_quantity: min_quantity,
              max_quantity: max_quantity
            }
          }
        }else{
          $(this).parents('.qtyField').find('.plus').removeClass('disabled');
        }
        if(window.isCartPage){
          $('body').addClass('loading');
        }
        let newQty = parseInt($(this).val());

        // If no moz products, show the quote modal and checkout buttons
        if (window.mozVendor.count  <= 0) {
          setTimeout(function() {
            $('.quote-modal-wrapper').removeClass('tw-hidden');
            $('.additional-checkout-buttons').removeClass('tw-hidden').show();
          }, 500);
        }

        if(newQty !== null && newQty !== '' && newQty !== undefined && newQty > -1) {
          UpdatePriceOnCarts(newQty);
          const row = $(this).closest('.cart__row');
          const variantId = row.data('variant-id');
          var index = row.data('index');
          console.log('row',row,index);
          self._updateCartJsByVariant(variantId, newQty, index);
        } else {
          // This will never execute but for safer side we are adding
          $(this).val("1");
          setTimeout(function(){
            $('body').removeClass("loading");  
          },100)
        }
      }
    });
  },
  _handleInstallation: async function(idInstallation, installationCost, addInstallation) {
    if(CartJSItems) {
      let variantId = this._getVariantId(idInstallation, 'installation_');
      let itemCart = CartJSItems.filter(item => item.key.includes(variantId));
      if(!itemCart.length) {
        return
      }
      itemCart = itemCart[0];
      let cartItemKey = itemCart.key;
      let properties = itemCart.properties;
      const {_bundleInstallationService, ...rest} = itemCart.properties;
      properties = rest;
      await this._changeOneItemCart({ id: cartItemKey, properties });
      CartJSItems = CartJSItems.map(item => {
        if(item.key.includes(variantId)) {
          item.properties = properties;
        }
        return item;
      });
    }
  },
  _cleanCartUi: function() {
  
  },
  _updateCartJsByVariant: function(variantId,newQty, index = 0){
    
    var self = this;
    const CartJSItems = CartJS.cart.items;
    var itemIndex, itemIndexToUpdate;
    if (!index) {
      itemIndex = CartJSItems.findIndex(({variant_id}) => variant_id === variantId);
      itemIndexToUpdate = itemIndex + 1;
    } else {
        itemIndex = index - 1;
        itemIndexToUpdate = index;
    }

    const {variant_id,quantity,handle,properties} = CartJSItems[itemIndex];
    
    const newProperties = {...properties};
    // Update __quantityBasedPricing to the correct tier price before sending to CartJS
    if (newProperties.__quantityBasedPricing !== undefined && typeof getTieredUnitPrice === 'function') {
      var tieredPrice = getTieredUnitPrice(variant_id, newQty);
      if (tieredPrice !== null) {
        newProperties.__quantityBasedPricing = tieredPrice.toString();
      }
    }
    CartJS.updateItem(itemIndexToUpdate,newQty,newProperties, {
      "success": function(data, textStatus, jqXHR) {
        self._handleInstallationVisibility(data.items);
        volMiniCartComponentSelected(data.items);
      },
    });
  },
  _handleInstallationVisibility: function(cartItems) {
    const installationWrapper = $('.js-cart-installation-wrapper')
    const installationItem = $('.cmp-installation');
    const sampleItems = cartItems.filter(item => item.handle.includes('sample'));
    let onlySamples = sampleItems.length === cartItems.length;
    if(onlySamples && installationItem.css('display') === 'block') {
      installationItem.css('display', 'none');
      installationWrapper.css('display', 'none');
      installationItem.addClass('hideBySamples');
    }else if(installationItem.hasClass('hideBySamples') && installationItem.css('display') === 'none') {
      installationItem.css('display', 'block');
      installationWrapper.css('display', 'block');
    }  
  },
  _checkByVariant: function(variantId,install,installationcost,wrapper,qty) {
    const CartJSItems = CartJS.cart.items;
    const itemIndex = CartJSItems.findIndex(({variant_id}) => variant_id === variantId);
    const itemIndexToUpdate = itemIndex + 1;
    const {variant_id,quantity,handle,properties} = CartJSItems[itemIndex];
    
    const newProperties = {...properties};
    if(install){
      newProperties['_bundleInstallationService'] = installationcost;
    } else if( typeof newProperties._bundleInstallationService !== 'undefined'){
      delete newProperties._bundleInstallationService;
    }
    $(wrapper).addClass('loading');
    CartJS.updateItem(itemIndexToUpdate,quantity,newProperties,{
      "success": function(data, textStatus, jqXHR) {
        $('.loading').removeClass('loading');
      },
    });
  },
  _updateCart: async function(items, itemsToDelete) {
    console.log('items _updateCart', items);
    try {
      const deleteResponse = await fetch('/cart/update.js', this._getRequestRoute({updates: itemsToDelete}));
      if (!deleteResponse.ok) throw new Error('Problem removing cart items');
      const addResponse = await fetch('/cart/add.js', this._getRequestRoute({items: items}));
      if (!addResponse.ok) throw new Error('Problem adding cart items');
      if(this.redirection === 'cart') {
        location.reload();
      } else {
        document.location.href = '/cart/checkout';
      }
    } catch(err){
      console.log(err)
    }
  },
  _updateOneItemCart: async function(items) {
    console.log('items in _updateOneItemCart', items);
    try {
      const response = await fetch('/cart/update.js', this._getRequestRoute({updates: items}));
      if (!response.ok){
        return null;
      }
      return await response.json();
    }catch(err){
      return null;
    }
  },
  _changeOneItemCart: async function(items) {
    console.log('items in _changeOneItemCart', items);
    try {
      const response = await fetch('/cart/change.js', this._getRequestRoute(items));
      if (!response.ok){
        return null;
      }
      return await response.json();
    }catch(err){
      return null;
    }
  },
  _getRequestRoute: function(object) {
    return {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(object)}
  },
  _getVariantId: function(str, removePrefix = null) {
    if(removePrefix){
      return str.replace(removePrefix, '').split(':')[0]
    }
    return str.split(':')[0]
  }
}

$( document ).on("ready", function() {
  UpdateCartItems._init();
  toggleCartReturnPolicy();
});
